import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivityMetricsV2Breakdown, ActivityMetricsV2MetricAuditRow, ActivityMetricsV2MetricResult } from '../../../../shared/models/activity-metrics-v2.model';

export interface ActivityMetricsMetricGroupViewModel {
  key: string;
  label: string;
  description: string | null;
  metrics: ActivityMetricsV2MetricResult[];
  breakdowns: ActivityMetricsV2Breakdown[];
}

@Component({
  selector: 'app-agent-performance-activity-metrics-metric-groups-widget',
  templateUrl: './agent-performance-activity-metrics-metric-groups-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-metric-groups-widget.component.scss']
})
export class AgentPerformanceActivityMetricsMetricGroupsWidgetComponent {
  @Input() groups: ActivityMetricsMetricGroupViewModel[] = [];
  @Input() selectedMetricKey: string | null = null;
  @Input() singleSubjectMetricAuditMap: { [metricKey: string]: ActivityMetricsV2MetricAuditRow | undefined } = {};
  @Input() widget_title = 'Metric Groups';
  @Output() metricSelected = new EventEmitter<string>();

  selectMetric(metricKey: string): void {
    this.metricSelected.emit(metricKey);
  }

  getTopBreakdownRows(breakdown: ActivityMetricsV2Breakdown | undefined, count = 8) {
    if (!breakdown?.rows?.length) {
      return [];
    }

    return [...breakdown.rows].sort((left, right) => (right.count ?? 0) - (left.count ?? 0)).slice(0, count);
  }

  formatPercent(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '-';
    }

    return `${value.toFixed(1)}%`;
  }

  getMetricAudit(metricKey: string): ActivityMetricsV2MetricAuditRow | undefined {
    return this.singleSubjectMetricAuditMap?.[metricKey];
  }

  trackByMetric(index: number, item: ActivityMetricsV2MetricResult): string {
    return `${index}:${item.metric_key}`;
  }

  trackByBreakdown(index: number, item: ActivityMetricsV2Breakdown): string {
    return `${index}:${item.breakdown_key}`;
  }
}
